import { useCallback, useEffect, useState } from "react";
import type { LiveInfo } from "@tih/shared";
import { fetchLive } from "../api/client";
import { useLiveSocket } from "./useLiveSocket";

export function useLiveInfo() {
  const [liveInfo, setLiveInfo] = useState<LiveInfo | null>(null);

  useEffect(() => {
    fetchLive()
      .then((data) => setLiveInfo(data.info))
      .catch(() => {
        /* Keep the current page state if live status cannot be loaded. */
      });
  }, []);

  const onLivePush = useCallback((next: LiveInfo) => setLiveInfo(next), []);
  useLiveSocket(onLivePush);

  return liveInfo;
}
